import {useMemo, useState} from "react";

import {RowSelectionState} from "@tanstack/react-table";

import {
  CustomActionResultRecordModel,
  CustomActionResultListModel,
} from "@/api/models/actions";
import useDataTablePagination from "@/hooks/useDataTablePagination";

type UseCustomActionResultsManageProps = {
  data: CustomActionResultRecordModel[];
  selectedRows: RowSelectionState;
  setSelectedRows: (updater: RowSelectionState) => void;
  onlySelected: boolean;
  setOnlySelected: (value: boolean) => void;
};

const useCustomActionResultsManage = (
  props: UseCustomActionResultsManageProps,
) => {
  const {data, selectedRows, onlySelected} = props;
  const [search, setSearch] = useState("");
  const {pagination, setPagination} = useDataTablePagination(0, 10);

  const filteredData = useMemo(() => {
    let records = data || [];

    if (search) {
      records = records.filter(row =>
        row.name.toLowerCase().includes(search.toLowerCase()),
      );
    }

    if (onlySelected) {
      records = records.filter(row => selectedRows[row.id]);
    }

    return records;
  }, [data, search, onlySelected, selectedRows]);

  const resultsData = useMemo<CustomActionResultListModel | undefined>(() => {
    if (!data) return undefined;

    const start = pagination.pageIndex * pagination.pageSize;
    const end = start + pagination.pageSize;
    const recordsSlice = filteredData.slice(start, end);

    return {
      records: recordsSlice,
      pagination: {
        size: pagination.pageSize,
        current: pagination.pageIndex + 1,
        pagesCount: Math.ceil(filteredData.length / pagination.pageSize),
        totalCount: filteredData.length,
      },
    };
  }, [filteredData, pagination, data]);

  return {
    search,
    setSearch,
    pagination,
    setPagination,
    resultsData,
  };
};

export default useCustomActionResultsManage;
